var FrAPISearchModel = require('./frApiSearchModel'),
    FrAPIGlobalOptionsModel = require('./frApiGlobalOptions'),
    FindAndRedactSearchModel =  require('../SearchModel');


/**
 * Can take either:
 * - array of search models or single search model
 * - optional options -- will set everything except for the 'term' in searches -- N/A if only one is provided
 * eg:
 *
 * findAndRedact: {

 	search: [{
       	term: 'German',
       	... any other SearchOptionsModel properties ( internally the class will be options )

       }],
       // Optional SearchOptionsModel
       	options: {
       	    noteType: 'redaction',
            note: {},
            zone: {},
            search
       	},


 */


/**
 * Takes the raw input as defined in the API and creates using objects from it
 * TODO: get out of Backbone methodology and construct the obj's outside the 'models', not within constructions, --
 * this should be simple but is complex to understand.
 *
 */

var FrApiModel = function( userInput ) {

    this._originalInput = JSON.parse( JSON.stringify( userInput ) ); // store in case ( and clone in case )

    this.validSearches = []; // FrApiSearches
    this.invalidSearches = [];

    this.globalOptions = null; // FrAPISearchModel -- but without the term

    this.validationErrors = [];

    this.init( userInput );

    return this;


};



_.extend( FrApiModel.prototype, {


    init: function( userInput ) {

        /* First create and validate the global options if it exists */

        if ( userInput.options ) {
            /* Could validate though currently nothing to validate */
            this.globalOptions = new FrAPIGlobalOptionsModel( userInput.options );

        }

        /* Now look at the searches */
        if ( !userInput.search ) {
            this.validationErrors.push( 'No Searches Provided ');
            return;
        }

        var userSearches = userInput.search instanceof Array ? userInput.search : [userInput.search];

        if ( userSearches.length < 1 ) {
           this.validationErrors.push( 'No Searches Provided ');
           return;
        }

        userSearches.forEach( function( search, i ) {

            /* jQuery provides a deep extend unlike underscore -- for nested properties like zone.fill */
            /* If we want to merge global reason codes into those of specific searches if those codes don't exist, look for other library/ code fn */
            var searchAttrs = $.extend( true, {},
                this._originalInput.options, // currently assumes valid ... ( nested parts can be overwritten )
                search // takes precedence
            );

            var model = new FrAPISearchModel( searchAttrs );

            if ( model.isValid() ) {

                this.validSearches.push( model );
            }
            else
            {
                this.invalidSearches.push( model );
                // for now not putting a # on the model -- maybe we store the message on the model too
                this.validationErrors.push( 'Search ' + (i+1) + ': ' + model.validationError );
            }

        }, this);


        //console.log( this );

    },

    getValidSearches: function() {
        return this.validSearches;
    },

    getInvalidSearches: function() {
        return this.invalidSearches;
    },

    getValidationErrors: function() {
        return this.validationErrors;
    },

    hasValidSearches: function() {
        return this.getValidSearches().length > 0;
    },

    hasInvalidSearches: function() {
        return this.getInvalidSearches().length > 0;
    },

    /* Bridge from searchAPI models to searchModels */
    getSearchesModelsFromApiModels: function( fnGetNewModel ) {

        var frSearchModels = [];

        this.getValidSearches().forEach( function( searchAPIModel ) {

            /* For time being set the note models from the note type */

            var noteType = searchAPIModel.get('noteType');

            var zone = searchAPIModel.get('zone'); // TODO: redact note or has customizable props .. for now they'd just be ignored ...

            /* Only override what would have been created in new note model if the attrs are specifically provided */
            var shapeAttrs = zone ? zone.toJSON() : {}; // want these passed in like coming in from DB ..

            // Always pass shape attributes at least as defined, this tell whether to use the last reason codes or not ...
            var newNoteModel = fnGetNewModel( noteType, shapeAttrs );

            var searchModel = new FindAndRedactSearchModel({
                fromAPI: true, // flag to differentiate from those manually entered one at a time
                searchOptions: searchAPIModel.get('search'),
                noteModel: newNoteModel
            });

            searchModel.setSearchTerms( searchAPIModel.get('term') );

            frSearchModels.push( searchModel );

        });

        return frSearchModels;

    }



});





module.exports = FrApiModel;





/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/models/api/frApiModel.js
 ** module id = 675
 ** module chunks = 0
 **/